<!-- Button -->
<button
    mat-icon-button
    [matMenuTriggerFor]="themesMenu"
    class="dark:text-[#E9EDEF] text-[#1e293b]"
>
    <div class="w-6 h-6 rounded-full border-2 dark:border-[#E9EDEF] border-[#1e293b]" [style.background-color]="getCurrentThemeColor()"></div>
</button>

<!-- Theme menu -->
<mat-menu
    [xPosition]="'before'"
    #themesMenu="matMenu"
    class="dark:bg-[#233138] bg-white"
>
    @for (theme of availableThemes; track theme.id) {
        <button
            mat-menu-item
            [ngClass]="{
                'dark:text-[#E9EDEF] text-[#1e293b]': true,
                'dark:bg-[#182229] bg-[#f8fafc]': theme.id === currentTheme,
                'hover:dark:bg-[#182229] hover:bg-[#f8fafc]': theme.id !== currentTheme
            }"
            (click)="setActiveTheme(theme.id)"
        >
            <span class="flex items-center">
                <span class="flex items-center justify-center mr-3">
                    <div class="w-6 h-6 rounded-full" [style.background-color]="theme.color"></div>
                </span>
                <span>{{ theme.name }}</span>
            </span>
        </button>
    }
</mat-menu> 